export default "__VITE_ASSET__DAA_QnMM__"